module.exports = __webpack_public_path__ + "static/media/sportEquipment.41af2453.svg";